import { omit } from 'ramda'
import { combineReducers } from 'redux'
import * as ActionTypes from '../../actions/actionTypes'

/** @reducer **/
const entities = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.HW_ORGANIZATIONS_FETCH_SUCCESS:
            const { organizations } = action.entities
            return { ...state, organizations }
        case ActionTypes.HW_ORGANIZATIONS_SAVE_SUCCESS:
        case ActionTypes.HW_ORGANIZATIONS_UPDATE_SUCCESS:
            return { ...state, organizations: { ...state.organizations, ...action.data.entities.organizations } }
        case ActionTypes.HW_ORGANIZATIONS_DELETE_SUCCESS:
            return { organizations: omit([action.data], state.organizations)}
        default:
            return state
    }
}

/** @reducer **/
const result = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.HW_ORGANIZATIONS_FETCH_SUCCESS:
            return [...action.result]
        case ActionTypes.HW_ORGANIZATIONS_SAVE_SUCCESS:
            return [...state, action.data.result]
        case ActionTypes.HW_ORGANIZATIONS_DELETE_SUCCESS:
            return state.filter(item => item !== action.data)
        default:
            return state
    }
}

/** @reducer **/
const isFetching = (state = false, action) => {
    switch (action.type) {
        case ActionTypes.HW_ORGANIZATIONS_FETCH_REQUEST:
            return true
        case ActionTypes.HW_ORGANIZATIONS_FETCH_SUCCESS:
        case ActionTypes.HW_ORGANIZATIONS_FETCH_FAILURE:
        case ActionTypes.HW_ORGANIZATIONS_SAVE_SUCCESS:
        case ActionTypes.HW_ORGANIZATIONS_SAVE_FAILURE:
        case ActionTypes.HW_ORGANIZATIONS_DELETE_SUCCESS:
        case ActionTypes.HW_ORGANIZATIONS_DELETE_FAILURE:
        case ActionTypes.HW_ORGANIZATIONS_UPDATE_SUCCESS:
        case ActionTypes.HW_ORGANIZATIONS_UPDATE_FAILURE:
            return false
        default:
            return state
    }
}

/** @reducer **/
const error = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.HW_ORGANIZATIONS_FETCH_FAILURE:
        case ActionTypes.HW_ORGANIZATIONS_SAVE_FAILURE:
        case ActionTypes.HW_ORGANIZATIONS_UPDATE_FAILURE:
        case ActionTypes.HW_ORGANIZATIONS_DELETE_FAILURE:
            return action.error
        case ActionTypes.HW_ORGANIZATIONS_FETCH_SUCCESS:
        case ActionTypes.HW_ORGANIZATIONS_SAVE_SUCCESS:
        case ActionTypes.HW_ORGANIZATIONS_UPDATE_SUCCESS:
        case ActionTypes.HW_ORGANIZATIONS_DELETE_SUCCESS:
            return null
        default:
            return null
    }
}

export default combineReducers({ entities, isFetching, result, error })



// WEBPACK FOOTER //
// ./src/reducers/hostelWorldReducers/hwOrganizations.js